import React, { useState, useEffect } from "react";
import axios from "axios";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form';
import { ReactSession } from 'react-client-session';
import {Helmet} from "react-helmet";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../Dashboard.css';
import classes from "./Settings.module.css";
import styles from '../Dashboard.module.css';
// import 'react-tabs/style/react-tabs.css';

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../../Footer/Footer";

const noAvatar = "https://hostpapasupport.com/knowledgebase/wp-content/uploads/2018/04/1-13.png";
const noCover = "https://res.cloudinary.com/omaha-code/image/upload/ar_4:3,c_fill,dpr_1.0,e_art:quartz,g_auto,h_396,q_auto:best,t_Linkedin_official,w_1584/v1561576558/mountains-1412683_1280.png";

function Settings() {
    const { name } = useParams();
    const { register, handleSubmit, control, reset, formState: { errors } } = useForm();
    const { register: register1, handleSubmit: handleSubmit1, reset: reset1 } = useForm();
    const { register: register2, handleSubmit: handleSubmit2, reset: reset2, formState: { errors: errors2 } } = useForm();
    const { register: register3, handleSubmit: handleSubmit3, reset: reset3, formState: { errors : errors3 } } = useForm();
    const { register: register4, handleSubmit: handleSubmit4, formState: { errors : errors4 } } = useForm();
    const [inputValue, setInputValue] = useState([]);
    const [avatar, setAvatar] = useState(null);
    const [avatarData, setAvatarData] = useState(null);
    const [cover, setCover] = useState(null);
    const [coverData, setCoverData] = useState(null);
    const [tabIndex, setTabIndex] = useState(0);
    ReactSession.setStoreType("localStorage");

    useEffect(() => {
        name && name === "password" ? setTabIndex(4) : setTabIndex(0);
    }, [name]);

    const logged_user = ReactSession.get("logged_user");

    useEffect(() => {
        // logged_user && navigate("/profile");

        // console.log(logged_user);
        axios.get(`${process.env.REACT_APP_API_URL}/api/user.php?uid=${logged_user}`)
            .then(res => {
                // console.log(res.data);
                setInputValue(res.data);
                setAvatarData(res.data.avatar_fix || noAvatar);
                setCoverData(res.data.cover_fix || noCover);
            }).catch(err => {
                console.log(err);
            })
    }, [])

    useEffect(() => {
        reset2({
            'name': inputValue.name,
            'city': inputValue.local,
            'country': inputValue.country,
            'bio': inputValue.bio
        });
        reset3({
            'f-link': inputValue.fblink,
            'tw-link': inputValue.twlink,
            'ig-link': inputValue.iglink,
            'paypal-link': inputValue.paypal,
            'web-link': inputValue.wlink,
        })
    }, [inputValue])

    const updateProfile = (data) => {
        const toast_id = toast.loading("Please wait...");
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/edit.php`, data, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then(res => {
            console.log(res.data);
            toast.update(toast_id, {render: res.data.message, autoClose: 5000, type: res.data.status, isLoading: false, closeOnClick: true, rtl: true});
        }).catch(err => {
            console.log(err);
        })
    }

    const updateUserInfo = (data) => {
        updateProfile(data);
    }

    const updateSocialLinks = (data) => {
        updateProfile(data);
    }

    const handleChange = (e) => {
        setInputValue(e.target.value);
    }

    const onAvatarChange = (e) => {
        setAvatar(e.target.files[0]);

        let reader = new FileReader();
        reader.onload = (e) => {
            setAvatarData(e.target.result);
        };
        
        if(e.target.files[0]){
            reader.readAsDataURL(e.target.files[0]);
        }else {
            setAvatar(inputValue.avatar);
        }
    }
    const onCoverChange = (e) => {
        setCover(e.target.files[0]);

        let reader = new FileReader();
        reader.onload = (e) => {
            setCoverData(e.target.result);
        };
        
        if(e.target.files[0]){
            reader.readAsDataURL(e.target.files[0]);
        }else {
            setCover(inputValue.cover);
        }
    }

    const changeAvatar = (e) => {
        const toast_id = toast.loading("Please wait...");
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/update.php`, {
                uid: logged_user,
                type: 1,
                avatar: avatar
            },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                console.log(res.data);
                if(res.data.type === 'success') {
                    ReactSession.set("avatar", res.data.avatar);
                }
                toast.update(toast_id, {render: res.data.message, autoClose: 5000, type: res.data.type, isLoading: false, closeOnClick: true, rtl: true});
            }).catch(err => {
                console.log(err);
            })
    }

    const changeCover = (e) => {
        const toast_id = toast.loading("Please wait...");
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/update.php`, {
                uid: logged_user,
                type: 2,
                cover: cover
            },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                toast.update(toast_id, {render: res.data.message, autoClose: 5000, type: res.data.type, isLoading: false});
            }).catch(err => {
                console.log(err);
            })
    }

    const updatePassword = (data) => {
        updateProfile(data);
    }

  return (
    <>
        <Helmet>
            <title>Settings</title>
        </Helmet>
        <div className="container_wrapper">
            <Header />
            <div className={`${styles.main} main`}>
                <ToastContainer />
                <Sidebar active="settings" />
                <div className={styles.main_content}>
                    <div className={`${styles.content_body} settings-component`}>
                        <div className={`${styles.title} mb-4`}>
                            <h5><i className="fa-solid fa-gears"></i> Channel Settings</h5>
                        </div>
                        <div className={`${styles.card} mb-5`}>
                            <div className="card-body">
                                <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                                    <TabList>
                                        <Tab><i className="fa-regular fa-circle-user"></i> Change Avatar</Tab>
                                        <Tab><i className="fa-regular fa-file-image"></i> Change Cover</Tab>
                                        <Tab><i className="fa-regular fa-user"></i> User Info</Tab>
                                        <Tab><i className="fa-solid fa-link"></i> Social Links</Tab>
                                        <Tab><i className="fa-solid fa-unlock"></i> Password</Tab>
                                    </TabList>
                                    <TabPanel>
                                        <form onSubmit={handleSubmit(changeAvatar)}>
                                            <div className="panel">
                                                <div className="panel-heading">
                                                    <h4 className="panel-title"><i className="icon icon-upload"></i>Change picture</h4>
                                                </div>
                                                <div className="panel-body">
                                                    <input type="hidden" id="changeavatar" name="changeavatar" value="yes" />
                                                    <div className={classes.avatar}>
                                                        {/* <img width="80px" height="80px" src="https://assets.codepen.io/3306515/IMG_2025.jpg" alt="" /> */}
                                                        <img width="80px" height="80px" src={avatarData} onError={e => {e.target.src = noAvatar}} alt="thumb" />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Choose picture (350px X 250px)</label>
                                                        <input {...register('avatar', {required: true})} type="file" className="form-control" onChange={onAvatarChange} id="imgInp" name="avatar" />
                                                    </div>
                                                    <div className="block mtop20">
                                                        <button className="btn btn-primary" type="submit">Upload avatar</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </TabPanel>
                                    <TabPanel>
                                        <form onSubmit={handleSubmit1(changeCover)}>
                                            <div className="panel">
                                                <div className="panel-heading">
                                                    <h4 className="panel-title"><i className="icon icon-upload"></i>Change Cover</h4>
                                                </div>
                                                <div className="panel-body">
                                                    <input type="hidden" id="changeavatar" name="changeavatar" value="yes" />
                                                    <div className={classes.cover}>
                                                        {/* <img width="100%" height="180px" src="https://res.cloudinary.com/omaha-code/image/upload/ar_4:3,c_fill,dpr_1.0,e_art:quartz,g_auto,h_396,q_auto:best,t_Linkedin_official,w_1584/v1561576558/mountains-1412683_1280.png" alt="" /> */}
                                                        <img width="100%" height="180px" src={coverData} onError={e => {e.target.src = noCover}} alt="thumb" />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Choose picture (350px X 250px)</label>
                                                        <input {...register1('cover', {required: true})} type="file" className="form-control" onChange={onCoverChange} id="imgInp" name="avatar" />
                                                    </div>
                                                    <div className="block mtop20">
                                                        <button className="btn btn-primary" type="submit">Upload cover</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </TabPanel>
                                    <TabPanel>
                                        <div className="mb-4">
                                            <h4>Profile</h4>
                                            <p>Manage your personal profile.</p>
                                        </div>
                                        <form onSubmit={handleSubmit2(updateUserInfo)}>
                                            <div className="form-group">
                                                <label>Full Name</label>
                                                <input {...register2('name', {required: true})}  control={control} className="form-control" type="text" onChange={handleChange} />
                                                {errors2.name && <p className={classes.error_msg}>This field cannot be empty, please enter your full name</p>}
                                            </div>
                                            <div className="form-group">
                                                <label>From City</label>
                                                <input {...register2('city')} control={control}  className="form-control" type="text" />
                                            </div>
                                            <div className="form-group">
                                                <label>From Country</label>
                                                <input {...register2('country')} control={control} className="form-control" type="text"/>
                                            </div>
                                            <div className="form-group">
                                                <label>Channel About</label>
                                                <textarea {...register2('bio')} control={control} className="form-control" rows="3"></textarea>
                                            </div>
                                            <input {...register2('changeuser')} type="hidden" className="hide" value="1" />
                                            <input {...register2('uid')} type="hidden" className="hide" value={logged_user} />
                                            <div className="form-group">
                                                <button className="btn btn-primary" type="submit">Save</button>
                                            </div>
                                        </form>
                                    </TabPanel>
                                    <TabPanel>
                                        <div className={classes.social_links}>
                                            <form onSubmit={handleSubmit3(updateSocialLinks)}>
                                                <div className="form-group">
                                                    <label htmlFor="inputEmail3MD"><i className="fab fa-facebook-f"></i> Facebook</label>
                                                    <div className="md-form mt-0">
                                                        <input {...register3('f-link')} type="text" className="input-secondary form-control" id="inputEmail3MD" placeholder="Facebook profile link" />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="inputPassword3MD"><i className="fab fa-dribbble-square"></i> Instagram</label>
                                                    <div className="md-form mt-0">
                                                        <input {...register3('ig-link')} type="text" className="input-secondary form-control" id="inputPassword3MD" placeholder="Instagram profile link" />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="inputPassword3MD"><i className="fab fa-twitter"></i> Twitter</label>
                                                    <div className="md-form mt-0">
                                                        <input {...register3('tw-link')} type="text" className="input-secondary form-control" id="inputPassword3MD" placeholder="Twitter profile link" />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="inputPassword3MD"><i className="fab fa-stack-overflow"></i> Paypal</label>
                                                    <div className="md-form mt-0">
                                                        <input {...register3('paypal-link')} type="text" className="input-secondary form-control" id="inputPassword3MD" placeholder="Paypal profile link" />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="inputPassword3MD"><i className="fab fa-github-alt"></i> Website</label>
                                                    <div className="md-form mt-0">
                                                        <input {...register3('web-link')} type="text" className="input-secondary form-control" id="inputPassword3MD" placeholder="Your Website link" />
                                                    </div>
                                                </div>
                                                <input {...register3('changeuser')} type="hidden" className="hide" value="1" />
                                                <input {...register3('uid')} type="hidden" className="hide" value={logged_user} />
                                                <div className="form-group">
                                                    <button className="btn btn-primary" type="submit">Save</button>
                                                </div>
                                            </form>
                                        </div>
                                    </TabPanel>
                                    <TabPanel>
                                        <form onSubmit={handleSubmit4(updatePassword)}>
                                            <div className="form-group">
                                                <label>Current Password</label>
                                                <input {...register4('oldpassword', {required: true})} control={control} className="form-control" placeholder="Enter Current Password" type="password" />
                                                {errors4.oldpassword && <p className={classes.error_msg}>This field cannot be empty, please enter old password</p>}
                                            </div>
                                            <div className="form-group">
                                                <label>New Password</label>
                                                <input
                                                    {...register4('pass1', {
                                                        required: true,
                                                        pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/
                                                    })}
                                                    className="form-control"
                                                    placeholder="Enter New Password"
                                                    type="password"
                                                />
                                                {errors4.pass1 && <p className={classes.error_msg}>Password must be at least 8 characters, at least 1 letter and 1 number</p>}
                                            </div>
                                            <div className="form-group">
                                                <label>Repeat Password</label>
                                                <input
                                                    {...register4('pass2',{
                                                        required: true,     
                                                        pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/
                                                    })}
                                                    className="form-control"
                                                    placeholder="Enter Repeat Password"
                                                    type="password"
                                                />
                                                {errors4.pass2 && <p className={classes.error_msg}>Password must be at least 8 characters, at least 1 letter and 1 number</p>}
                                            </div>
                                            <input {...register4('change-password')} type="hidden" id="change-password" value="1" />
                                            <input {...register4('uid')} type="hidden" className="hide" value={logged_user} />
                                            <div className="form-group">
                                                <button type="submit" className="btn btn-primary">Save</button>
                                            </div>
                                        </form>
                                    </TabPanel>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    </>
  );
}

export default Settings;